class DBProductAndProductModifierCategoryCoder extends DBXLSXCoder
{
    protected mainEntity() {
        return { entity: "ProductModifierCategory", predicateFormat: "deletedAt == null", relations:["products"] };
    }

    columns() : any[] {
        let cols = [
            { title: "MODIFIER CATEGORY ID", width: "10%", align: "center" },
            { title: "MODIFIER CATEGORY NAME", width: "10%", align: "center" },
            { title: "PRODUCT ID", width: "20%", align: "center" },
            { title: "PRODUCT NAME", width: "20%", align: "center" },
        ]
        return cols;
    }

    aditionalImportEntities(){
        return [            
            { entity: "Product", predicateFormat: "deletedAt == null" }
        ]
    }

    protected importRow(row:any){
        
        let mcID        = row["MODIFIER CATEGORY ID"];
        let mcName      = row["MODIFIER CATEGORY NAME"];
        let productID   = row["PRODUCT ID"];
        let productName = row["PRODUCT NAME"];

        let mc = this.queryEntityByField("ProductModifierCategory", "identifier", mcID) as ProductModifierCategory;
        if (mc == null) return;

        let product = this.queryEntityByField("Product", "identifier", productID) as Product;
        if (product == null) return;

        mc.addProductsObject(product);
        
        MIOLog("ADDING PRODUCT: " + this.rowIndex + "/" + this.rows.length + ": " + mc.name + " -> " + product.name );
    }

    protected exportTitle() : string { return "Product and Product Modifier Categories"; }
                
    protected exportSortDescriptors() { 
        return [
            MIOSortDescriptor.sortDescriptorWithKey("name", false)            
        ]; 
    }

    protected parseObjects(objects:MIOManagedObject[]) : any[] { 
        let items = [];
        for (let index = 0; index < objects.length; index++) {
            let obj = objects[index] as ProductModifierCategory;
            for (let pi = 0; pi < obj.products.count; pi++) {
                let p = obj.products.objectAtIndex(pi);
                let item = this.parse(obj, p);
                items.addObject(item);                    
            }
        }

        return items;
    }


    protected parse(mc:ProductModifierCategory, product:Product): any {
        let item = {
            "MODIFIER CATEGORY ID": mc.identifier,
            "MODIFIER CATEGORY NAME": mc.name,
            "PRODUCT ID": product.identifier,
            "PRODUCT NAME": product.name
        }

        return item;
    }
}